/* unplugin-vue-components disabled */
import {PulseSearch} from 'components/pulse'

export default {
  components: {PulseSearch},
  mixins: [ModelValue(String)],
  props: {
    loading: {type: Boolean, required: false}
  },
  data() {
    return {
      mobile_search_open: false
    }
  },
  methods: {
    focusMobileSearch() {
      this.$nextTick(() => this.$refs.mobile_search?.focus())
    }
  }
}
